import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ThemeProvider } from 'react-css-themr';
import { DatePicker, IconButton } from 'react-toolbox';
import moment from 'moment';
import cx from 'classnames';

import inputStyles from 'styles/input';
import styles from './styles.scss';
import RTDatePicker from './rtDatePicker.scss';
import RTButton from './rtButton.scss';

const theme = { RTDatePicker, RTButton };

class DateInput extends Component {
  constructor(props) {
    super(props);
    this.toggleDatePicker = this.toggleDatePicker.bind(this);
    this.showDatePicker = this.showDatePicker.bind(this);
    this.hideDatePicker = this.hideDatePicker.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onMobileChange = this.onMobileChange.bind(this);
    this.onPickerChange = this.onPickerChange.bind(this);
    this.state = { showPicker: false, value: props.value || '' };
  }

  componentWillReceiveProps = newProps => (newProps.value !== this.props.value ?
    this.setState({ value: newProps.value }) : null);

  onChange = event => this.setState({
    value: event.target.value,
  }, this.props.onChange(event.target.value));

  onMobileChange = (event) => {
    const value = event.target.value ? moment(event.target.value, 'YYYY-MM-DD').format('MM/DD/YYYY') : '';
    this.setState({ value }, this.props.onChange(value));
  }

  onPickerChange = (value) => {
    const date = moment(value).format('MM/DD/YYYY');
    this.setState({
      value: date.toString(),
      showPicker: false,
    }, () => {
      this.props.onChange(date);
      if (this.props.onBlur) this.props.onBlur(date);
    });
  }

  toggleDatePicker = value => (this.props.disabled ? null : this.setState({ showPicker: value }));

  showDatePicker = () => this.toggleDatePicker(true);

  hideDatePicker = () => this.toggleDatePicker(false);

  render = () => {
    const { label, disabled } = this.props;
    const { required, error, className, maxDate,
            minDate, ...otherProps } = this.props;
    const requiredText = required ? ' *' : '';
    const errorText = error || '';
    const rootClassNames = cx({
      [styles.datePickerWrapper]: true,
      [this.props.className]: className,
      [inputStyles.errored]: errorText,
    });
    const labelClassNames = cx({
      [inputStyles.label]: true,
      [styles.errorText]: errorText,
    });
    const inputClassnames = cx(inputStyles.inputElement, styles.inputElement);
    const mobileInputClassnames = cx(inputStyles.inputElement, styles.mobileInputElement);
    const errorMessageClassNames = cx(
      { [styles.errorText]: errorText,
        [styles.errorMessage]: errorText },
    );
    const momentDate = this.state.value ? moment(this.state.value, ['MM-DD-YYYY', 'YYYY-MM-DD']) : moment();
    const nativeDate = this.state.value ?
      momentDate.format('YYYY-MM-DD').toString() :
      '';
    return (<ThemeProvider theme={theme}>
      <div className={rootClassNames}>
        <DatePicker
          autoOk
          {...otherProps}
          minDate={minDate}
          maxDate={maxDate}
          active={this.state.showPicker}
          onChange={this.onPickerChange}
          onEscKeyDown={this.hideDatePicker}
          onOverlayClick={this.hideDatePicker}
          onDismiss={this.hideDatePicker}
          value={momentDate.toDate()}
          sundayFirstDayOfWeek
        />
        {label && <label htmlFor="date" className={labelClassNames}>{label}{requiredText}</label>}
        <input
          {...otherProps}
          type="text"
          value={this.state.value}
          className={inputClassnames}
          onChange={this.onChange}
          placeholder={this.props.placeholder}
        />
        <input
          {...otherProps}
          type="date"
          value={nativeDate}
          className={mobileInputClassnames}
          onChange={this.onMobileChange}
          placeholder={this.props.placeholder}
        />
        <span className={errorMessageClassNames}>{errorText}</span>
        <IconButton
          className={cx(styles.icon, { [styles.disabled]: disabled })}
          icon="date_range"
          onClick={this.showDatePicker}
        />
      </div>
    </ThemeProvider>);
  }
}

DateInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  label: PropTypes.node,
  required: PropTypes.bool,
  error: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
};

export default DateInput;



// WEBPACK FOOTER //
// ./client/app/shared/components/DatePicker/index.jsx